import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import { statsFunctionWrapper } from '@fiverr-private/homepage_utils';
import { GetJobInfoArgs } from '@fiverr-private/jtbd_sdk';

export const shouldDisplayCard = async (args: GetJobInfoArgs) => {
    try {
        const fetcher = () =>
            axios.get(`${args.externalServicesInfo.retentionKimera.url}/app_download/should_show`, {
                params: { source: 'tailored_homepage' },
            });

        const { data } = await statsFunctionWrapper(fetcher, 'jtbd.download_app.should_show')();

        if (!data || !data.should_show_app_download) {
            return false;
        }
    } catch (error: any) {
        logger.error(error, {
            description: `Error while checking shouldDisplay for download app card`,
        });

        return false;
    }

    return true;
};
